import $ from 'jquery';

export default class Filters {
  constructor(el) {
    this.el = el;

    const buttons = el.querySelectorAll('[data-button]');
    const panels = el.querySelectorAll('[data-panel]');
    this.searchFilters = el.querySelectorAll(
      '[data-panel] input[type="radio"]'
    );
    this.searchInput = el.querySelector('.m-filters__searchPanel input');
    this.searchButton = el.querySelector('.m-filters__searchPanel label');
    this.viewMore = el.parentElement.querySelector('[data-more]');
    this.currentFilters = el.parentElement.querySelector(
      '[data-current-filters]'
    );
    this.page_num = 1;
    const activeClass = 'is-active';
    const self = this;

    buttons.forEach((button, i) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();

        const isActive = event.currentTarget.classList.contains(activeClass);

        buttons.forEach((button) => {
          button.classList.remove(activeClass);
        });

        panels.forEach((panel) => {
          panel.classList.add('hidden');

          if (panel.classList.contains('m-filters__searchPanel')) {
            panel.classList.remove('flex');
          }
        });

        if (!isActive) {
          const panel = panels[i];

          event.currentTarget.classList.add(activeClass);

          if (panel) {
            panel.classList.remove('hidden');

            if (panel.classList.contains('m-filters__searchPanel')) {
              panel.classList.add('flex');
              this.searchInput.focus();
            }
          }
        }
      });
    });

    this.searchInput.addEventListener('keypress', function (e) {
      if (e.key === 'Enter') {
        self.page_num = 1;
        self.handleSearch(e);
      }
    });

    this.searchButton.addEventListener('click', function (e) {
      self.page_num = 1;
      self.handleSearch(e);
    });

    this.viewMore.addEventListener('click', function (e) {
      e.preventDefault();
      self.page_num++;
      self.handleSearch(e);
    });

    this.searchFilters.forEach((input) => {
      input.addEventListener('change', function (e) {
        self.page_num = 1;
        self.handleSearch(e);
      });
    });

    self.handleSearch();
  }

  handleSearch() {
    const radios = this.el.querySelectorAll(
      '[data-panel] input[type="radio"]:checked'
    );
    const featuredId = document.getElementById('FeaturedNews').dataset.id;
    const keyword = this.searchInput.value;
    const termFilters = [];
    const el = this.el;
    const page_num = this.page_num;
    const viewMore = this.viewMore;
    const self = this;
    const resultsContainer = el.parentElement.querySelector('[data-results]');
    this.currentFilters.innerHTML = '';

    console.log('Featured ID', featuredId);

    if (keyword) {
      this.currentFilters.innerHTML += `<li data-keyword class="pr-3 flex pt-2">${keyword} <svg data-remove class="h-5 w-5 mt-1 fill-current cursor-pointer" aria-hidden="true">
      <use xlink:href="#icon--close" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg></li>`;
    }

    radios.forEach((radio) => {
      this.currentFilters.innerHTML += `<li data-taxonomy="${
        radio.name
      }" data-taxid="${radio.id}" class="pr-3 flex pt-2">${radio.getAttribute(
        'data-term-name'
      )} <svg data-remove class="h-5 w-5 mt-1 fill-current cursor-pointer" aria-hidden="true">
      <use xlink:href="#icon--close" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg></li>`;
      termFilters.push({ tax: radio.name, term: radio.id });
    });

    const addedFilters = this.currentFilters.querySelectorAll('[data-remove]');

    addedFilters.forEach((filter) => {
      filter.addEventListener('click', function (e) {
        if (e.target.parentElement.dataset.keyword != undefined) {
          self.searchInput.value = '';
        } else {
          el.querySelector(
            `[data-term-id="${e.target.parentElement.getAttribute(
              'data-taxid'
            )}"]`
          ).checked = false;
        }
        e.target.remove();
        self.handleSearch(e);
      });
    });

    const data = {
      action: 'get_search_results',
      keyword: keyword,
      terms: termFilters,
      paged: this.page_num || 1,
    };

    if (keyword === '' && !termFilters.length) {
      data.exclude = featuredId;
    }

    $.ajax({
      url: window.ajax_object.ajax_url,
      method: 'POST',
      data,
    })
      .done(function (data) {
        if (page_num == 1) {
          resultsContainer.innerHTML = '';
        }

        if (data) {
          var returnedData = JSON.parse(data);

          if (page_num < returnedData.pages) {
            viewMore.classList.remove('hidden');
          } else {
            viewMore.classList.add('hidden');
          }
          resultsContainer.innerHTML += returnedData.results;
        } else {
          resultsContainer.innerHTML += returnedData.results;
        }
      })
      .fail(function (xhr, status, error) {
        const errorMessage =
          xhr.status + ': ' + xhr.statusText + status + error;

        console.log('Error - ' + errorMessage);
      });
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/Filters.js